const faClock = {
  prefix: 'fal',
  iconName: 'clock',
  icon: [
    512,
    512,
    [128339, 'clock-four'],
    'f017',
    'M480 256a224 224 0 1 1 -448 0 224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zM240 112l0 144c0 5.4 2.7 10.3 7.1 13.3l96 64c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L272 247.4 272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16z',
  ],
};
export default faClock;
